import React from "react";

const PolicyPage = ({ title, children }) => (
  <main className="main-content" id="MainContent">
    <div className="page-width page-width--narrow page-content">
      <header className="section-header">
        <h1 className="section-header__title">{title}</h1>
      </header>
      <div className="rte rte--nomargin"><div className="std">{children}</div></div>
    </div>
  </main>
);

export default PolicyPage;
